import {decode, encode} from "./Base64";
import * as BarCodeConstants from "../constants/BarCodeConstants";
import {isNullOrUndefined} from "./NamaCommon";

export function fromURL(url, serializer) {
    if (!url)
        return null;
    url = decode(url);
    let objects = url.split(BarCodeConstants.contextsSeparator);
    let objectList = [];
    for (let i = 0; i < objects.length; i++) {
        let properties = objects[i].split(BarCodeConstants.entriesSepaarator);
        let propertiesMap = {};
        for (let j = 0; j < properties.length; j++) {
            let keyValue = properties[j].split(BarCodeConstants.keyValueSepaarator);
            if (keyValue.length != 2)
                continue;
            propertiesMap[keyValue[0]] = keyValue[1];
        }
        if (propertiesMap) {
            let object = serializer.fromProperties(propertiesMap);
            if (object != null) {
                objectList.push(object);
            }
        }
    }
    return objectList;
}

export function toUrl(objects, serializer) {
    let builder = "";
    if (objects) {
        for (let i = 0; i < objects.length; i++) {
            builder = addProperties(builder, serializer.toProperties(objects[i]));
            if (i < objects.length - 1) {
                builder += BarCodeConstants.contextsSeparator;
            }
        }
    }
    return encode(builder);
}

function addProperties(builder, properties) {
    let j = 0;
    for (let [key, value] of properties) {
        if (value)
            value = value.id ? value.id : value;
        builder += key + BarCodeConstants.keyValueSepaarator + (isNullOrUndefined(value) ? "" : value);
        if (j < properties.size - 1) {
            builder += BarCodeConstants.entriesSepaarator;

        }
        j++;
    }
    return builder;
}

export function listToString(list) {
    list = list || [];
    return list.join(BarCodeConstants.listSeperator);
}

export function stringToList(str) {
    if (!str)
        return [];
    return str.split(BarCodeConstants.listSeperator);
}